<template>
  <component
    :is="isPreview() ? 'img' : NuxtImg"
    :sizes="isPreview() ? null : props.sizes"
    :class="[
      logo
        ? 'max-h-[55px] min-h-[28px] w-auto inline-block aspect-auto! max-desktop:h-[28px]'
        : 'dbc-c-image dbc-c-image--cover',
      imageFormatClass,
    ]"
    :src="`${useRuntimeConfig().public.cms}${src}`"
    :style="[asIsAspectRatioStyling]"
    :alt="altText"
  />
  <NuxtLink
    v-if="copyright"
    aria-hidden="true"
    tabindex="-1"
    class="dbc-c-image__copyright"
    to="#copyright"
    @click="isCopyrightsOpen = true"
    >{{ copyrights.indexOf(copyright) + 1 }}</NuxtLink
  >
</template>

<script setup lang="ts">
import { NuxtImg } from '#components'

export interface Props {
  format?: ImageFormat | null
  src?: string | undefined
  logo?: boolean
  width?: number
  height?: number
  copyright?: string | null
  sizes?: string
  alt?: string | null
}

const props = withDefaults(defineProps<Props>(), {
  sizes: 'xs:320 sm:640 md:768 lg:1024 xl:1280',
})

const route = useRoute()

const copyrights = inject('copyrights') as string[]
const isCopyrightsOpen = useState<boolean>('dbc-is-copyrights-open')

const imageFormatClass = computed(() => {
  if (!props.format) return 'dbc-c-image--4-3'

  if (props.format === 'as-is') return null

  return `dbc-c-image--${props.format.replace('f', '')}`
})

const asIsAspectRatioStyling = computed(() => {
  if (!props.width || !props.height) return null

  if (props.format !== 'as-is') return null

  return {
    width: props.width + 'px',
    height: props.height + 'px',
    'aspect-ratio': `${props.width} / ${props.height}`,
  }
})

const altText = props.copyright
  ? props.alt?.concat(' copyright ', props.copyright)
  : props.alt
</script>
